module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-vibrate-fill-fa560b7b.svg";